import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, forwardRef, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList, BarChart, Bar } from "recharts";
import { Box, Paper, Typography, Select, MenuItem, Divider } from "@mui/material";
import { Nav } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { getInfoAdminSystem } from "utils/HelperFunction";
// Sku
import { getReportChartSku } from "../redux/handlers/report/getReportChartSku.handler";
import { getReportChartSkuDay } from "../redux/handlers/report/getReportChartSkuDay.handler";
// Partner
import { getReportChartPartner } from "../redux/handlers/report/getReportChartPartner.handler";
import { getReportChartPartnerDay } from "../redux/handlers/report/getReportChartPartnerDay.handler";
// Reserve
import { getReportChartReserve } from "../redux/handlers/report/getReportChartReserve.handler";
import { getReportChartReserveDay } from "../redux/handlers/report/getReportChartReserveDay.handler";
import { getReportChartBranch } from "../redux/handlers/report/getReportChartBranch.handler";
import { getReportChartBranchDay } from "../redux/handlers/report/getReportChartBranchDay.handler";
function BranchCreationChart(param) {
    var data = param.data, dateKey = param.dateKey, title = param.title, period = param.period;
    return /*#__PURE__*/ _jsx("div", {
        className: "card card-st-3 mb-3",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body px-xl-3",
            children: [
                /*#__PURE__*/ _jsxs(Typography, {
                    fontSize: 16,
                    fontWeight: "bold",
                    sx: {
                        textAlign: "center"
                    },
                    children: [
                        title,
                        /*#__PURE__*/ _jsx("br", {}),
                        /*#__PURE__*/ _jsx("span", {
                            style: {
                                fontSize: 14,
                                fontWeight: 400
                            },
                            children: period
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Divider, {
                    sx: {
                        my: 2
                    }
                }),
                /*#__PURE__*/ _jsx(ResponsiveContainer, {
                    width: "100%",
                    height: 350,
                    children: /*#__PURE__*/ _jsxs(LineChart, {
                        data: data,
                        children: [
                            /*#__PURE__*/ _jsx(CartesianGrid, {
                                strokeDasharray: "3 3",
                                stroke: "#ccc"
                            }),
                            /*#__PURE__*/ _jsx(XAxis, {
                                dataKey: dateKey,
                                tick: {
                                    fontSize: 12
                                }
                            }),
                            /*#__PURE__*/ _jsx(YAxis, {
                                tick: {
                                    fontSize: 12
                                },
                                allowDecimals: false
                            }),
                            /*#__PURE__*/ _jsx(Tooltip, {}),
                            /*#__PURE__*/ _jsx(Legend, {
                                verticalAlign: "bottom"
                            }),
                            /*#__PURE__*/ _jsx(Line, {
                                type: "monotone",
                                dataKey: "revenueA",
                                name: "จำนวนสาขาร้านค้าใหม่",
                                stroke: "#ff9700",
                                strokeWidth: 3,
                                dot: {
                                    fill: "#ff9700",
                                    r: 5
                                },
                                activeDot: {
                                    r: 7
                                }
                            }),
                            /*#__PURE__*/ _jsx(Line, {
                                type: "monotone",
                                dataKey: "revenueB",
                                name: "จำนวนสาขาร้านค้าสะสม",
                                stroke: "#4f7df0",
                                strokeWidth: 3,
                                dot: {
                                    fill: "#4f7df0",
                                    r: 5
                                },
                                activeDot: {
                                    r: 7
                                }
                            })
                        ]
                    })
                })
            ]
        })
    });
}
export function Dashboard() {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var canViewAllCharts = (adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userRoleId) === 1;
    var currentYear = new Date().getFullYear();
    var years = Array.from({
        length: 5
    }, function(_, i) {
        return currentYear - i;
    }); // 5 ปีย้อนหลัง
    var _useState = _sliced_to_array(useState(currentYear), 2), year = _useState[0], setYear = _useState[1];
    var _useState1 = _sliced_to_array(useState(new Date()), 2), selectedMonth = _useState1[0], setSelectedMonth = _useState1[1]; // เปลี่ยนเป็น Date object
    var _useState2 = _sliced_to_array(useState([]), 2), dataChartSku = _useState2[0], setDataChartSku = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), dataChartSkuDay = _useState3[0], setDataChartSkuDay = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), dataChartReserve = _useState4[0], setDataChartReserve = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), dataChartReserveDay = _useState5[0], setDataChartReserveDay = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), dataChartPartner = _useState6[0], setDataChartPartner = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), dataChartPartnerDay = _useState7[0], setDataChartPartnerDay = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), dataChartBranch = _useState8[0], setDataChartBranch = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), dataChartBranchDay = _useState9[0], setDataChartBranchDay = _useState9[1];
    var getReportChartBranchReducer = useAppSelector(function(state) {
        return state.getReportChartBranchReducer;
    });
    var getReportChartBranchDayReducer = useAppSelector(function(state) {
        return state.getReportChartBranchDayReducer;
    });
    var getReportChartSkuReducer = useAppSelector(function(state) {
        return state.getReportChartSkuReducer;
    });
    var getReportChartSkuDayReducer = useAppSelector(function(state) {
        return state.getReportChartSkuDayReducer;
    });
    var getReportChartReserveReducer = useAppSelector(function(state) {
        return state.getReportChartReserveReducer;
    });
    var getReportChartPartnerReducer = useAppSelector(function(state) {
        return state.getReportChartPartnerReducer;
    });
    var getReportChartPartnerDayReducer = useAppSelector(function(state) {
        return state.getReportChartPartnerDayReducer;
    });
    var getReportChartReserveDayReducer = useAppSelector(function(state) {
        return state.getReportChartReserveDayReducer;
    });
    // Load data
    useEffect(function() {
        if (!canViewAllCharts) {
            return;
        }
        var controller = new AbortController();
        dispatch(getReportChartSku({
            year: String(year)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getReportChartReserve({
            year: String(year)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getReportChartPartner({
            year: String(year)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getReportChartBranch({
            year: String(year)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj,
            signal: controller.signal
        }));
        dispatch(getReportChartBranchDay({
            month: moment(selectedMonth).format("YYYY-MM")
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj,
            signal: controller.signal
        }));
        dispatch(getReportChartSkuDay({
            month: moment(selectedMonth).format("YYYY-MM")
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getReportChartPartnerDay({
            month: moment(selectedMonth).format("YYYY-MM")
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getReportChartReserveDay({
            month: moment(selectedMonth).format("YYYY-MM")
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        return function() {
            return controller.abort();
        };
    }, [
        year,
        selectedMonth,
        canViewAllCharts
    ]);
    useEffect(function() {
        setIsLoading(getReportChartSkuReducer.isFetching || getReportChartSkuDayReducer.isFetching || getReportChartPartnerReducer.isFetching || getReportChartPartnerDayReducer.isFetching || getReportChartReserveReducer.isFetching || getReportChartReserveDayReducer.isFetching || getReportChartBranchReducer.isFetching || getReportChartBranchDayReducer.isFetching);
        if (getReportChartSkuReducer.data) {
            var _getReportChartSkuReducer_data;
            setDataChartSku(getReportChartSkuReducer === null || getReportChartSkuReducer === void 0 ? void 0 : (_getReportChartSkuReducer_data = getReportChartSkuReducer.data) === null || _getReportChartSkuReducer_data === void 0 ? void 0 : _getReportChartSkuReducer_data.data);
        }
        if (getReportChartSkuDayReducer.data) {
            var _getReportChartSkuDayReducer_data;
            setDataChartSkuDay(getReportChartSkuDayReducer === null || getReportChartSkuDayReducer === void 0 ? void 0 : (_getReportChartSkuDayReducer_data = getReportChartSkuDayReducer.data) === null || _getReportChartSkuDayReducer_data === void 0 ? void 0 : _getReportChartSkuDayReducer_data.data);
        }
        if (getReportChartPartnerReducer.data) {
            var _getReportChartPartnerReducer_data;
            setDataChartPartner(getReportChartPartnerReducer === null || getReportChartPartnerReducer === void 0 ? void 0 : (_getReportChartPartnerReducer_data = getReportChartPartnerReducer.data) === null || _getReportChartPartnerReducer_data === void 0 ? void 0 : _getReportChartPartnerReducer_data.data);
        }
        if (getReportChartPartnerDayReducer.data) {
            var _getReportChartPartnerDayReducer_data;
            setDataChartPartnerDay(getReportChartPartnerDayReducer === null || getReportChartPartnerDayReducer === void 0 ? void 0 : (_getReportChartPartnerDayReducer_data = getReportChartPartnerDayReducer.data) === null || _getReportChartPartnerDayReducer_data === void 0 ? void 0 : _getReportChartPartnerDayReducer_data.data);
        }
        if (getReportChartReserveReducer.data) {
            var _getReportChartReserveReducer_data;
            setDataChartReserve(getReportChartReserveReducer === null || getReportChartReserveReducer === void 0 ? void 0 : (_getReportChartReserveReducer_data = getReportChartReserveReducer.data) === null || _getReportChartReserveReducer_data === void 0 ? void 0 : _getReportChartReserveReducer_data.data);
        }
        if (getReportChartReserveDayReducer.data) {
            var _getReportChartReserveDayReducer_data;
            setDataChartReserveDay(getReportChartReserveDayReducer === null || getReportChartReserveDayReducer === void 0 ? void 0 : (_getReportChartReserveDayReducer_data = getReportChartReserveDayReducer.data) === null || _getReportChartReserveDayReducer_data === void 0 ? void 0 : _getReportChartReserveDayReducer_data.data);
        }
        if (getReportChartBranchReducer.data) {
            setDataChartBranch(getReportChartBranchReducer.data.data);
        }
        if (getReportChartBranchDayReducer.data) {
            setDataChartBranchDay(getReportChartBranchDayReducer.data.data);
        }
    }, [
        getReportChartSkuReducer,
        getReportChartSkuDayReducer,
        getReportChartPartnerReducer,
        getReportChartPartnerDayReducer,
        getReportChartReserveReducer,
        getReportChartReserveDayReducer,
        getReportChartBranchReducer,
        getReportChartBranchDayReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "pagezoom",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "fs-24 mb-2",
                    children: "Dashboard"
                })
            }),
            canViewAllCharts ? /*#__PURE__*/ _jsxs("div", {
                className: "row gx-xl-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-xl-6 col-md-12",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "card card-st-3 mb-3",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card-body px-xl-3",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "row gx-xl-4",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-9 col-md-6"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-3 col-md-6",
                                                children: /*#__PURE__*/ _jsx(Select, {
                                                    value: year,
                                                    onChange: function(e) {
                                                        return setYear(e.target.value);
                                                    },
                                                    size: "small",
                                                    fullWidth: true,
                                                    sx: {
                                                        height: 38
                                                    },
                                                    children: years.map(function(y) {
                                                        return /*#__PURE__*/ _jsx(MenuItem, {
                                                            value: y,
                                                            children: y
                                                        }, y);
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card card-st-3 mb-3",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body px-xl-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Box, {
                                            sx: {
                                                display: "flex",
                                                justifyContent: "space-between"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Typography, {
                                                fontSize: 16,
                                                fontWeight: "bold",
                                                sx: {
                                                    textAlign: "center",
                                                    width: "100%"
                                                },
                                                children: [
                                                    "รายงานกราฟ SKU เดิม และ SKU ใหม่รายเดือน",
                                                    /*#__PURE__*/ _jsx("br", {}),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        style: {
                                                            fontSize: 14,
                                                            fontWeight: 400
                                                        },
                                                        children: year
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Divider, {
                                            sx: {
                                                my: 2
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(ResponsiveContainer, {
                                            width: "100%",
                                            height: 350,
                                            children: /*#__PURE__*/ _jsxs(LineChart, {
                                                data: dataChartSku,
                                                children: [
                                                    /*#__PURE__*/ _jsx(CartesianGrid, {
                                                        strokeDasharray: "3 3",
                                                        stroke: "#ccc"
                                                    }),
                                                    /*#__PURE__*/ _jsx(XAxis, {
                                                        dataKey: "month",
                                                        tick: {
                                                            fontSize: 12
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(YAxis, {
                                                        tick: {
                                                            fontSize: 12
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(Tooltip, {}),
                                                    /*#__PURE__*/ _jsx(Legend, {
                                                        verticalAlign: "bottom"
                                                    }),
                                                    "// เส้น SKU สะสม",
                                                    /*#__PURE__*/ _jsx(Line, {
                                                        type: "monotone",
                                                        dataKey: "revenueB",
                                                        name: "SKU สะสม",
                                                        stroke: "#4f7df0",
                                                        strokeWidth: 3,
                                                        dot: {
                                                            fill: "#4f7df0",
                                                            r: 5
                                                        },
                                                        activeDot: {
                                                            r: 7
                                                        },
                                                        children: /*#__PURE__*/ _jsx(LabelList, {
                                                            dataKey: "value",
                                                            position: "top",
                                                            fontSize: 12,
                                                            style: {
                                                                fontWeight: "bold"
                                                            }
                                                        })
                                                    }),
                                                    "// เส้น SKU ใหม่",
                                                    /*#__PURE__*/ _jsx(Line, {
                                                        type: "monotone",
                                                        dataKey: "revenueA",
                                                        name: " SKU ใหม่",
                                                        stroke: "#ff9700",
                                                        strokeWidth: 3,
                                                        dot: {
                                                            fill: "#ff9700",
                                                            r: 5
                                                        },
                                                        activeDot: {
                                                            r: 7
                                                        },
                                                        children: /*#__PURE__*/ _jsx(LabelList, {
                                                            dataKey: "value",
                                                            position: "top",
                                                            fontSize: 12,
                                                            style: {
                                                                fontWeight: "bold"
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card card-st-3 mb-3",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body px-xl-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Box, {
                                            sx: {
                                                display: "flex",
                                                justifyContent: "space-between"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Typography, {
                                                fontSize: 16,
                                                fontWeight: "bold",
                                                sx: {
                                                    textAlign: "center",
                                                    width: "100%"
                                                },
                                                children: [
                                                    "รายงานกราฟสะสม Partner รายเดือน",
                                                    /*#__PURE__*/ _jsx("br", {}),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        style: {
                                                            fontSize: 14,
                                                            fontWeight: 400
                                                        },
                                                        children: year
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Divider, {
                                            sx: {
                                                my: 2
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(ResponsiveContainer, {
                                            width: "100%",
                                            height: 350,
                                            children: /*#__PURE__*/ _jsxs(LineChart, {
                                                data: dataChartPartner,
                                                children: [
                                                    /*#__PURE__*/ _jsx(CartesianGrid, {
                                                        strokeDasharray: "3 3",
                                                        stroke: "#ccc"
                                                    }),
                                                    /*#__PURE__*/ _jsx(XAxis, {
                                                        dataKey: "month",
                                                        tick: {
                                                            fontSize: 12
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(YAxis, {
                                                        tick: {
                                                            fontSize: 12
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(Tooltip, {}),
                                                    /*#__PURE__*/ _jsx(Legend, {
                                                        verticalAlign: "bottom"
                                                    }),
                                                    "// เส้น partner ใหม่",
                                                    /*#__PURE__*/ _jsx(Line, {
                                                        type: "monotone",
                                                        dataKey: "revenueA",
                                                        name: "partner ใหม่",
                                                        stroke: "#ff9700",
                                                        strokeWidth: 3,
                                                        dot: {
                                                            fill: "#ff9700",
                                                            r: 5
                                                        },
                                                        activeDot: {
                                                            r: 7
                                                        },
                                                        children: /*#__PURE__*/ _jsx(LabelList, {
                                                            dataKey: "value",
                                                            position: "top",
                                                            style: {
                                                                fontWeight: "bold"
                                                            }
                                                        })
                                                    }),
                                                    "// เส้น partner สะสม",
                                                    /*#__PURE__*/ _jsx(Line, {
                                                        type: "monotone",
                                                        dataKey: "revenueB",
                                                        name: "partner สะสม",
                                                        stroke: "#4f7df0",
                                                        strokeWidth: 3,
                                                        dot: {
                                                            fill: "#4f7df0",
                                                            r: 5
                                                        },
                                                        activeDot: {
                                                            r: 7
                                                        },
                                                        children: /*#__PURE__*/ _jsx(LabelList, {
                                                            dataKey: "value",
                                                            position: "top",
                                                            style: {
                                                                fontWeight: "bold"
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(BranchCreationChart, {
                                data: dataChartBranch,
                                dateKey: "month",
                                title: "รายงานกราฟสะสม สาขาร้านค้าใหม่ รายเดือน",
                                period: year
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card card-st-3 mb-3",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body px-xl-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Box, {
                                            sx: {
                                                display: "flex",
                                                justifyContent: "space-between"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Typography, {
                                                fontSize: 16,
                                                fontWeight: "bold",
                                                sx: {
                                                    textAlign: "center",
                                                    width: "100%"
                                                },
                                                children: [
                                                    "กราฟสะสมใบจองตามสถานะรายเดือน",
                                                    /*#__PURE__*/ _jsx("br", {}),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        style: {
                                                            fontSize: 14,
                                                            fontWeight: 400
                                                        },
                                                        children: year
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Divider, {
                                            sx: {
                                                my: 2
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(ResponsiveContainer, {
                                            width: "100%",
                                            height: 350,
                                            children: /*#__PURE__*/ _jsxs(BarChart, {
                                                data: dataChartReserve,
                                                children: [
                                                    /*#__PURE__*/ _jsx(CartesianGrid, {
                                                        strokeDasharray: "3 3",
                                                        stroke: "#ccc"
                                                    }),
                                                    /*#__PURE__*/ _jsx(XAxis, {
                                                        dataKey: "month",
                                                        tick: {
                                                            fontSize: 12
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(YAxis, {
                                                        tick: {
                                                            fontSize: 12
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(Tooltip, {
                                                        formatter: function(value, name) {
                                                            if (name === "มูลค่าใบจอง") return value.toFixed(2);
                                                            return value;
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(Legend, {
                                                        verticalAlign: "bottom"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Bar, {
                                                        dataKey: "count",
                                                        name: "จำนวนใบจอง",
                                                        fill: "#4b77ca",
                                                        children: /*#__PURE__*/ _jsx(LabelList, {
                                                            dataKey: "count",
                                                            position: "top",
                                                            fontSize: 12
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx(Bar, {
                                                        dataKey: "net",
                                                        name: "มูลค่าใบจอง",
                                                        fill: "#f48138",
                                                        children: /*#__PURE__*/ _jsx(LabelList, {
                                                            dataKey: "net",
                                                            position: "top",
                                                            fontSize: 12,
                                                            formatter: function(value) {
                                                                return value.toFixed(2);
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-xl-6 col-md-12",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "card card-st-3 mb-3",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card-body px-xl-3",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "row gx-xl-4",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-9 col-md-6"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-3 col-md-6",
                                                children: /*#__PURE__*/ _jsx(Box, {
                                                    sx: {
                                                        ml: "auto"
                                                    },
                                                    children: /*#__PURE__*/ _jsx(DatePicker, {
                                                        selected: selectedMonth,
                                                        onChange: function(date) {
                                                            return setSelectedMonth(date);
                                                        },
                                                        dateFormat: "MM/yyyy",
                                                        showMonthYearPicker: true,
                                                        fullWidth: true,
                                                        className: "form-control body1",
                                                        placeholderText: "เลือกเดือน",
                                                        customInput: /*#__PURE__*/ _jsx("button", {
                                                            type: "button",
                                                            style: {
                                                                padding: "8px 16px",
                                                                border: "1px solid #ddd",
                                                                borderRadius: "4px",
                                                                background: "white",
                                                                cursor: "pointer",
                                                                fontSize: "14px"
                                                            },
                                                            children: moment(selectedMonth).format("MM/YYYY")
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card card-st-3 mb-3",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body px-xl-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Box, {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Typography, {
                                                fontSize: 16,
                                                fontWeight: "bold",
                                                sx: {
                                                    textAlign: "center",
                                                    flex: 1
                                                },
                                                children: [
                                                    "รายงานกราฟ SKU เดิม และ SKU ใหม่รายวัน",
                                                    /*#__PURE__*/ _jsx("br", {}),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        style: {
                                                            fontSize: 14,
                                                            fontWeight: 400
                                                        },
                                                        children: moment(selectedMonth).locale("th").format("MMMM YYYY")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Divider, {
                                            sx: {
                                                my: 2
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(ResponsiveContainer, {
                                            width: "100%",
                                            height: 350,
                                            children: /*#__PURE__*/ _jsxs(LineChart, {
                                                data: dataChartSkuDay,
                                                children: [
                                                    /*#__PURE__*/ _jsx(CartesianGrid, {
                                                        strokeDasharray: "3 3",
                                                        stroke: "#ccc"
                                                    }),
                                                    /*#__PURE__*/ _jsx(XAxis, {
                                                        dataKey: "date",
                                                        tick: {
                                                            fontSize: 12
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(YAxis, {
                                                        tick: {
                                                            fontSize: 12
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(Tooltip, {}),
                                                    /*#__PURE__*/ _jsx(Legend, {
                                                        verticalAlign: "bottom"
                                                    }),
                                                    "// เส้น SKU ใหม่",
                                                    /*#__PURE__*/ _jsx(Line, {
                                                        type: "monotone",
                                                        dataKey: "revenueA",
                                                        name: " SKU ใหม่",
                                                        stroke: "#ff9700",
                                                        strokeWidth: 3,
                                                        dot: {
                                                            fill: "#ff9700",
                                                            r: 5
                                                        },
                                                        activeDot: {
                                                            r: 7
                                                        },
                                                        children: /*#__PURE__*/ _jsx(LabelList, {
                                                            dataKey: "value",
                                                            position: "top",
                                                            fontSize: 12,
                                                            style: {
                                                                fontWeight: "bold"
                                                            }
                                                        })
                                                    }),
                                                    "// เส้น SKU สะสม",
                                                    /*#__PURE__*/ _jsx(Line, {
                                                        type: "monotone",
                                                        dataKey: "revenueB",
                                                        name: "SKU สะสม",
                                                        stroke: "#4f7df0",
                                                        strokeWidth: 3,
                                                        dot: {
                                                            fill: "#4f7df0",
                                                            r: 5
                                                        },
                                                        activeDot: {
                                                            r: 7
                                                        },
                                                        children: /*#__PURE__*/ _jsx(LabelList, {
                                                            dataKey: "value",
                                                            position: "top",
                                                            fontSize: 12,
                                                            style: {
                                                                fontWeight: "bold"
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card card-st-3 mb-3",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body px-xl-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Box, {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Typography, {
                                                fontSize: 16,
                                                fontWeight: "bold",
                                                sx: {
                                                    textAlign: "center",
                                                    flex: 1
                                                },
                                                children: [
                                                    "รายงานกราฟสะสม Partner รายวัน",
                                                    /*#__PURE__*/ _jsx("br", {}),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        style: {
                                                            fontSize: 14,
                                                            fontWeight: 400
                                                        },
                                                        children: moment(selectedMonth).locale("th").format("MMMM YYYY")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Divider, {
                                            sx: {
                                                my: 2
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(ResponsiveContainer, {
                                            width: "100%",
                                            height: 350,
                                            children: /*#__PURE__*/ _jsxs(LineChart, {
                                                data: dataChartPartnerDay,
                                                children: [
                                                    /*#__PURE__*/ _jsx(CartesianGrid, {
                                                        strokeDasharray: "3 3",
                                                        stroke: "#ccc"
                                                    }),
                                                    /*#__PURE__*/ _jsx(XAxis, {
                                                        dataKey: "day",
                                                        tick: {
                                                            fontSize: 12
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(YAxis, {
                                                        tick: {
                                                            fontSize: 12
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(Tooltip, {}),
                                                    /*#__PURE__*/ _jsx(Legend, {
                                                        verticalAlign: "bottom"
                                                    }),
                                                    "// เส้น partner ใหม่",
                                                    /*#__PURE__*/ _jsx(Line, {
                                                        type: "monotone",
                                                        dataKey: "revenueA",
                                                        name: "partner ใหม่",
                                                        stroke: "#ff9700",
                                                        strokeWidth: 3,
                                                        dot: {
                                                            fill: "#ff9700",
                                                            r: 5
                                                        },
                                                        activeDot: {
                                                            r: 7
                                                        },
                                                        children: /*#__PURE__*/ _jsx(LabelList, {
                                                            dataKey: "value",
                                                            position: "top",
                                                            fontSize: 12,
                                                            style: {
                                                                fontWeight: "bold"
                                                            }
                                                        })
                                                    }),
                                                    "// เส้น partner สะสม",
                                                    /*#__PURE__*/ _jsx(Line, {
                                                        type: "monotone",
                                                        dataKey: "revenueB",
                                                        name: "partner สะสม",
                                                        stroke: "#4f7df0",
                                                        strokeWidth: 3,
                                                        dot: {
                                                            fill: "#4f7df0",
                                                            r: 5
                                                        },
                                                        activeDot: {
                                                            r: 7
                                                        },
                                                        children: /*#__PURE__*/ _jsx(LabelList, {
                                                            dataKey: "value",
                                                            position: "top",
                                                            fontSize: 12,
                                                            style: {
                                                                fontWeight: "bold"
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(BranchCreationChart, {
                                data: dataChartBranchDay,
                                dateKey: "day",
                                title: "รายงานกราฟสะสม สาขาร้านค้าใหม่ รายวัน",
                                period: moment(selectedMonth).locale("th").format("MMMM YYYY")
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card card-st-3 mb-3",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body px-xl-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Box, {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Typography, {
                                                fontSize: 16,
                                                fontWeight: "bold",
                                                sx: {
                                                    textAlign: "center",
                                                    flex: 1
                                                },
                                                children: [
                                                    "กราฟสะสมใบจองตามสถานะรายวัน",
                                                    /*#__PURE__*/ _jsx("br", {}),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        style: {
                                                            fontSize: 14,
                                                            fontWeight: 400
                                                        },
                                                        children: moment(selectedMonth).locale("th").format("MMMM YYYY")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Divider, {
                                            sx: {
                                                my: 2
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(ResponsiveContainer, {
                                            width: "100%",
                                            height: 350,
                                            children: /*#__PURE__*/ _jsxs(BarChart, {
                                                data: dataChartReserveDay,
                                                children: [
                                                    /*#__PURE__*/ _jsx(CartesianGrid, {
                                                        strokeDasharray: "3 3",
                                                        stroke: "#ccc"
                                                    }),
                                                    /*#__PURE__*/ _jsx(XAxis, {
                                                        dataKey: "date",
                                                        tick: {
                                                            fontSize: 12
                                                        },
                                                        label: {
                                                            // value: "วันที่",
                                                            position: "insideBottom",
                                                            offset: -5
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(YAxis, {
                                                        tick: {
                                                            fontSize: 12
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(Tooltip, {
                                                        labelFormatter: function(label) {
                                                            return "วันที่ ".concat(label);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(Legend, {
                                                        verticalAlign: "bottom"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Bar, {
                                                        dataKey: "count",
                                                        name: "จำนวนใบจอง",
                                                        fill: "#4b77ca",
                                                        children: /*#__PURE__*/ _jsx(LabelList, {
                                                            dataKey: "count",
                                                            position: "top",
                                                            fontSize: 12
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx(Bar, {
                                                        dataKey: "net",
                                                        name: "มูลค่าใบจอง",
                                                        fill: "#f48138",
                                                        children: /*#__PURE__*/ _jsx(LabelList, {
                                                            dataKey: "net",
                                                            position: "top",
                                                            fontSize: 12,
                                                            formatter: function(value) {
                                                                return value.toFixed(2);
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
}
